// A workflow's status (docs/03 "WorkflowTemplate"): any status can be set at any time except
// `active`, which needs a published version. The marketplace lists active workflows only.
import { messages } from "../i18n";
import type { Tone } from "../ui/tones";
import type { TemplateStatus, WorkflowSummary } from "./types";

export const STATUS_TONE: Record<TemplateStatus, Tone> = { draft: "primary", active: "green", disabled: "orange", archived: "gray" };

export interface StatusAction {
  status: TemplateStatus;
  label: string;
  /** Why it cannot be set now, if it cannot. */
  blocked?: string;
}

const ACTIONS: TemplateStatus[] = ["active", "disabled", "archived", "draft"];

export function statusActions(w: WorkflowSummary): StatusAction[] {
  const t = messages().catalog.status;
  return ACTIONS.filter((s) => s !== w.status).map((status) => {
    const action = { status, label: t.actions[status] };
    return status === "active" && w.latest_version === null ? { ...action, blocked: t.publishFirst } : action;
  });
}
